import React, {Component} from 'react';
import styled from 'styled-components';
import Button from '../common/Button';
import Grid from '../common/Grid';
import colors from '../utilities/colors';
import spacings from "../utilities/spacings";

const logo_source = "https://www.seo-usa.org/wp-content/uploads/2020/04/logo.png";

const HeaderWrapper = styled.div`
  background: ${colors.white};
  padding: ${spacings.s} 0;
  border-bottom: 1px solid ${colors.lightGrey};
  
  .logo {
    width: 200px;
    height: 100px;
    background: url("${logo_source}");
    background-size: cover;
    
    @media (max-width: 850px) {
      width: 120px;
      height: 60px;
    }
  }
`;

class Index extends Component {
    render() {
        return (
            <div>
                <HeaderWrapper>
                    <Grid.Wrapper class={''}>
                        <div className={'u-separate-contents u-align-items-center u-flex'}>
                            <div className={'logo'}></div>
                            <Button
                                class={'btn-primary'}
                                label={'Make a donation'}
                                tag={'a'}
                                href={'https://give.seo-usa.org/give/280843/#!/donation/checkout'}/>
                        </div>
                    </Grid.Wrapper>
                </HeaderWrapper>
            </div>
        );
    }
}

export default Index;
